import { createStore as reduxCreateStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { Preferences } from '@capacitor/preferences';

import loggerMiddleWare from './helpers/loggerMiddleWare';
import Repository from 'repository';
import { createAPI } from 'API';
import { rootReducerWithCurrentProjectWrapper } from './reducers';

const storeProxy = {
  dispatch: (...args) => store.dispatch(...args),
  getState: () => store.getState(),
  subscribe: (...args) => store.subscribe(...args),
};

export const repository = new Repository(storeProxy, Preferences);

export const api = createAPI(storeProxy);

const store = reduxCreateStore(
  rootReducerWithCurrentProjectWrapper,
  applyMiddleware(thunk.withExtraArgument({api, repository}), loggerMiddleWare),
);

global.setNetworkStatus = (network_status) => store.dispatch({type: "SET_NETWORK_STATUS", network_status})

export default store;
